<ng-template #linkItem let-p>
  <a
    class="pagination__item"
    paiRipple
    [class.pagination__item--active]="currentPage() === p"
    [attr.aria-current]="currentPage() === p ? 'page' : null"
    [routerLink]="['.']"
    queryParamsHandling="merge"
    [queryParams]="getParams(p)"
    [attr.aria-label]="'Pagination.PageLabel' | translate: { page: p }"
    >{{ p }}</a
  >
</ng-template>

<ng-template #iconLinkTpl let-p let-labelKey="labelKey">
  <a
    class="pagination__btn"
    paiRipple
    [routerLink]="['.']"
    queryParamsHandling="merge"
    [queryParams]="getParams(p)"
    [attr.aria-label]="labelKey | translate"
  >
    <pai-icon icon="chevron-right" />
  </a>
</ng-template>

<div class="pagination">
  @if (showPrevPageBtn()) {
    <ng-template
      [ngTemplateOutlet]="iconLinkTpl"
      [ngTemplateOutletContext]="{ $implicit: currentPage() - 1, labelKey: 'Pagination.PrevPageLabel' }"
    />
  }

  <div class="pagination__list">
    <!--  first item-->
    <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: 1 }" />

    <!--  lower dots if -->
    @if (showLowerDots()) {
      <div class="pagination__dots"></div>
    }

    <!--  the middle items -->
    @for (p of middleItems(); track p) {
      <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: p }" />
    }

    <!--  upper dots -->
    @if (showUpperDots()) {
      <div class="pagination__dots"></div>
    }

    <!--  show last item-->
    <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: this.pageCount() }" />
  </div>

  @if (showNextPageBtn()) {
    <ng-template
      [ngTemplateOutlet]="iconLinkTpl"
      [ngTemplateOutletContext]="{ $implicit: currentPage() + 1, labelKey: 'Pagination.NextPageLabel' }"
    />
  }
</div>
